
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_1ggv8_3",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_1ggv8_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_1ggv8_30",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_1ggv8_1",
  "error": "awsui_error_14mhv_1ggv8_3",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_1ggv8_1",
  "root": "awsui_root_14mhv_1ggv8_74",
  "label": "awsui_label_14mhv_1ggv8_85",
  "info": "awsui_info_14mhv_1ggv8_98",
  "description": "awsui_description_14mhv_1ggv8_102",
  "constraint": "awsui_constraint_14mhv_1ggv8_103",
  "hints": "awsui_hints_14mhv_1ggv8_110",
  "constraint-has-error": "awsui_constraint-has-error_14mhv_1ggv8_111",
  "secondary-control": "awsui_secondary-control_14mhv_1ggv8_115",
  "controls": "awsui_controls_14mhv_1ggv8_119",
  "label-hidden": "awsui_label-hidden_14mhv_1ggv8_119",
  "control": "awsui_control_14mhv_1ggv8_119",
  "error__message": "awsui_error__message_14mhv_1ggv8_138",
  "visually-hidden": "awsui_visually-hidden_14mhv_1ggv8_142"
};
  